<template>
  <div id="app">
    <el-container>
      <el-header>
        <div style="display: flex;align-items: center;justify-content: space-between ;height: 60px;">
          <div style="left: 20px;">
            <img src="@/assets/icon/logo.png" alt="" style="cursor: pointer;width: 100%;height: 100%;" @click="tohome">
            <!-- <h1 style="cursor: pointer;" @click="tohome">湖北省地质图集</h1> -->
          </div>
          <!-- class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click="entersearch"></el-button> -->
          <div>
              <el-input 
              size="300"
              placeholder="请输入想要搜索的地图名称" 
              v-model.trim="input" 
              :clearable="true"
              style="min-width: 300px;border-radius: 20px;"
              suffix-icon="el-icon-search"
              @suffix-click="entersearch"
              @keyup.enter.native="entersearch"
              class="custom-input"
              >
              </el-input>
          </div>
          <div style="display: flex; flex-direction: row;width: 100px;justify-content: space-between ;align-items: center;">
            <div class="r-tool" @click="tohome">
              <img src="@/assets/icon/sy.png" class="r-img">
            </div>
            <div class="r-tool" @click="goback">
              <img src="@/assets/icon/fh.png" class="r-img">
            </div>
          </div>
          <div></div>
        </div>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <el-footer>
        <a href="https://dzj.hubei.gov.cn/"><p style="margin-right: 50px;">主办单位：湖北省地质局</p></a>
        <a href="https://dzj.hubei.gov.cn/chy/"><p style="margin-right: 50px;">建设单位：湖北省国土测绘院</p></a>
        <p>联系我们：178****1245</p>
      </el-footer>
    </el-container>
  </div>
</template>
<script>

export default {
  name: "App",
  components: {
    // HelloWorld
  },
  data() {
    return {
      input: '',
    };
  },
  created(){
  },
  methods: {
    entersearch() {
      //跳转页面方法
      this.$router.push({ path: '/search', query: { id: this.input }})
      // console.log(this.input)
    },
    tohome() {
      //跳转页面方法
      this.$router.push({ path: '/main' })
    },
    goback() {
      //跳转页面方法
      if (this.$route.path != '/main'){
        this.$router.back()
      } 
    },
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
  width: 100%;
  height: 100%;
}

.el-header {
  background-color: #B3C0D1;
  color: #333;
  text-align: center;
  height: 60px;
  border-radius: 5px;
}

.el-footer {
  background-color: #B3C0D1;
  color: #333;
  text-align: center;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
}

.el-main {
  background-color: #E9EEF3;
  color: #333;
  text-align: center;
  height: 87vh;
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding: 0; */
  padding: 0px !important;
}
.el-row {
  margin-bottom: 10px;
  height: 5%;
  /* width: 90%; */
  margin-top: 25px;
  margin-right: 15px;
  width: 80vw;
  left: 10vw;
  position: absolute;

  &:last-child {
    margin-bottom: 0;
  }

  z-index: 2;
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.r-tool{
    display: flex;
    flex-direction: column;
    cursor: pointer;
    margin-right: 10px;
}
.r-img{
    width: 40px;
    height: 40px;
}

.r-tool:hover img {
  transform: scale(1.2);
}


/* :deep(.el-input__inner){
  border-radius: 20px;
  /* border: 0; 
} */

.custom-input .el-input__inner{
  border-radius: 20px; /* 设置圆角 */
  font-size: 18px;
}
.custom-input .el-input__suffix{
  width:40px;
  height:35px;
}
</style>
